export const ACTIVATE_ACCOUNT = 'activate-account';
const activateAccount = () => ({ type: ACTIVATE_ACCOUNT });
export default activateAccount;
